import type { FaireProductEntity } from "../../entity_types/product";

export const p_yxsyqpsrn8: FaireProductEntity = {
  token: "p_yxsyqpsrn8",
  type: "product",
  name: "Children's Arkansas Razorbacks Established Bows Red Tee",
  brandToken: "b_1bf5q9xdtj",
  brandName: "LivyLu",
  imageUrl: "https://cdn.faire.com/fastly/b5fa1ecd6a333db94cb786c126bb6301464c6afc2d87eaf246886b29c418b0ab.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Wooo Pig Sooie!!!  Show off your University of Arkansas Razorbacks Hog Spirit with this tee that is perfect for Game Day or Any Day! \n\n\n2 oz, 100% Airlume Combed & Ringspun Cotton\nAthletic Heather is 90/10 Airlume Combed & Ringspun Cotton/Polyester\nAdditional Heather is 52/48 Airlume Combed & Ringspun Cotton/Polyester\nPre-Shrunk\nSide Seam\nTear Away Label\nOfficially Licensed \n\nMEASUREMENTS:\n\nBody Length:\n\n6M – 11 ¼”\n\n12M – 12 ¼”\n\n18M – 13 ¼”\n\n24M – 14 ¼”\n\n2T – 15.5”\n\n3T – 16.5”\n\n4T – 17.5”\n\n5T – 18.5”\n\nS – 20 7/8”\n\nM – 22 1/8”\n\nL – 23 3/8”\n\n \n\nBody Width:\n\n6M – 10”\n\n12M – 10.5”\n\n18M – 11”\n\n24M – 11.5”\n\n2T – 12”\n\n3T – 13”\n\n4T – 14”\n\n5T – 15”\n\nS – 15 ¼”\n\nM – 16 ¼”\n\nL – 17 ¼”",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:30.455Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
